module.exports = __webpack_public_path__ + "img/mood_die.d0a24f2c.png";